import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { getHomeRouteByRole } from "@/lib/api";

export default function RoleRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else {
      navigate(getHomeRouteByRole(user.role), { replace: true });
    }
  }, [user, navigate]);
  return null;
}
